import React from "react";
import classes from "./styles.module.scss";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Link } from "react-router-dom";

/**
 * Page header: title block on the left, tools on the right.
 *
 * Props are unchanged from the original component — `text`, `path`,
 * `btn_name`, `exportToCSV`, `search`, `onSearch`, `searchTitle` — with two
 * additions: `subtitle` for a line of context under the title, and `children`
 * for page-specific controls (filters, date pickers) that sit alongside the
 * built-in tools.
 */
const Heading = (props) => {
    const hasAddButton = props.path && props.path !== "#" && props.path !== "/";
    const showSearch = typeof props.onSearch === "function";

    return (
        <div className={classes.heading}>
            <div className={classes.title_block}>
                <h2 className={classes.title}>{props.text}</h2>
                {props.subtitle ? (
                    <p className={classes.subtitle}>{props.subtitle}</p>
                ) : null}
            </div>

            <div className={classes.actions}>
                {props.children}

                {showSearch ? (
                    <div className={classes.search}>
                        <SearchRoundedIcon className={classes.search_icon} />
                        <input
                            type="search"
                            placeholder={props.searchTitle ? props.searchTitle : "Search"}
                            name="search"
                            value={props.search}
                            onChange={props.onSearch}
                        />
                    </div>
                ) : null}

                {props.exportToCSV ? (
                    <button
                        type="button"
                        className={classes.ghost_button}
                        onClick={props.exportToCSV}
                    >
                        <FileDownloadOutlinedIcon />
                        <span>Export CSV</span>
                    </button>
                ) : null}

                {hasAddButton ? (
                    <Link to={props.path} className={classes.primary_link}>
                        <button type="button" className={classes.primary_button}>
                            <AddRoundedIcon />
                            <span>{props.btn_name}</span>
                        </button>
                    </Link>
                ) : null}
            </div>
        </div>
    );
};

export default Heading;
